import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import WorkoutMaxNew from '../components/WorkoutMaxNew.js';
import WorkoutMaxEdit from '../components/WorkoutMaxEdit.js';

const formatMaxValue = (item, dataMax) => {
	const maxValue = dataMax?.[item.WORKOUTID]?.MAX;

	if (maxValue === undefined || maxValue === null || maxValue === '') {
		return '-';
	}

	return `${maxValue}${parseInt(item.TYPEID) === 1 ? ' kg' : ''}`;
};

const formatRecordValue = (item) => {
	if (parseInt(item.TYPEID) === 1) {
		return `${item.WEIGHT} kg`;
	}

	const mins = String(item.MINS ?? 0);
	const secs = String(item.SECS ?? 0).padStart(2, '0');

	return `${mins}:${secs}`;
};

export default function WorkoutMax({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [dataMax, setDataMax] = useState([]);
	const [dataWorkout, setDataWorkout] = useState([]);
	const [dataDetail, setDataDetail] = useState({});
	const [showNew, setShowNew] = useState(false);
	const [showEdit, setShowEdit] = useState(false);

	useEffect(() => {
		getData('');
	}, []);

	const getData = (search) => {
		setLoading(true);

		post('getListWorkoutMax', {search: search})
			.then((res) => {
				setData(res.data.data);
				setDataMax(res.data.data_max);
				setDataWorkout(res.data.data_workout);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleNew = () => {
		setShowNew(true);
	};

	const closeNew = () => {
		setShowNew(false);
	};

	const updateWorkoutMaxRowNew = (row) => {
		setData(row.data);
		setDataMax(row.data_max);
		setDataWorkout(row.data_workout);
	};

	const handleEdit = (rec) => {
		setShowEdit(true);
		setDataDetail(rec);
	};

	const closeEdit = () => {
		setShowEdit(false);
	};

	const updateWorkoutMaxRowEdit = (row) => {
		setData(row.data);
		setDataMax(row.data_max);
		setDataWorkout(row.data_workout);
	};

	const updateWorkoutMaxRowDelete = (row) => {
		setData(row.data);
		setDataMax(row.data_max);
		setDataWorkout(row.data_workout);
	};

	const groupedData = data.reduce((groups, item) => {
		const lastGroup = groups[groups.length - 1];

		if (lastGroup && lastGroup.workoutId === item.WORKOUTID) {
			lastGroup.records.push(item);
			return groups;
		}

		groups.push({
			workoutId: item.WORKOUTID,
			workoutName: item.NAME,
			workoutTypeId: item.TYPEID,
			accentColor: item.COLOR,
			records: [item]
		});

		return groups;
	}, []);

	const summaryCards = [
		{label: 'Cviky', value: groupedData.length},
		{label: 'Záznamy', value: data.length},
		{label: 'Poslední update', value: data.length > 0 ? data[0].CRDTS : '-'}
	];

	const list = groupedData.map((group) => {
		const sampleItem = group.records[0];

		return (
			<section className="workoutmax-page__section" key={`workout_${group.workoutId}`} style={{'--workoutmax-accent': group.accentColor || '#8acaa3'}}>
				<div className="workoutmax-page__section-head">
					<div className="workoutmax-page__section-head-main">
						<div className="workoutmax-page__section-kicker">{parseInt(group.workoutTypeId) === 1 ? 'Váhový výkon' : 'Časový výkon'}</div>
						<h2 className="workoutmax-page__section-title">{group.workoutName}</h2>
					</div>
					<div className="workoutmax-page__section-total">{formatMaxValue(sampleItem, dataMax)}</div>
				</div>

				<div className="workoutmax-page__list">
					{group.records.map((item) => (
						<article className="workoutmax-page__row" key={`item_${item.ID}`}>
							<div className="workoutmax-page__row-main">
								<button type="button" className="workoutmax-page__icon-button" onClick={() => handleEdit(item)} aria-label={`Upravit záznam ${item.NAME} ${item.CRDTS}`}>
									<img className="icon1 edit" alt="" />
								</button>
								<div className="workoutmax-page__row-text">
									<div className="workoutmax-page__row-date">{item.CRDTS}</div>
									<div className="workoutmax-page__row-meta">{item.AGE} let, {item.MYWEIGHT} kg</div>
								</div>
							</div>
							<div className="workoutmax-page__row-value">{formatRecordValue(item)}</div>
						</article>
					))}
				</div>
			</section>
		);
	});

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showNew handleNew={handleNew} />
				<WorkoutMaxNew showNew={showNew} closeNew={closeNew} updateWorkoutMaxRowNew={updateWorkoutMaxRowNew} dataWorkout={dataWorkout} />
				<WorkoutMaxEdit showEdit={showEdit} closeEdit={closeEdit} updateWorkoutMaxRowEdit={updateWorkoutMaxRowEdit} updateWorkoutMaxRowDelete={updateWorkoutMaxRowDelete} data={dataDetail} dataWorkout={dataWorkout} />

				<div className={`page workoutmax-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<section className="workoutmax-page__hero">
						<div className="workoutmax-page__hero-main">
							<h1 className="workoutmax-page__title">Osobní rekordy podle cviků</h1>
						</div>
						<div className="workoutmax-page__summary-grid">
							{summaryCards.map((card) => (
								<div className="workoutmax-page__summary-card" key={card.label}>
									<div className="workoutmax-page__summary-label">{card.label}</div>
									<div className="workoutmax-page__summary-value">{card.value}</div>
								</div>
							))}
						</div>
					</section>

					<div className="workoutmax-page__shell">
						{list.length > 0 ? list : <div className="workoutmax-page__empty">Zatím nejsou uložené žádné maximálky.</div>}
					</div>
				</div>
			</div>
		</>
	);
}
